import React, { useState, useEffect, useCallback, Fragment } from "react";

import { CourceList } from '../uiParts/settings/CourceList';
import { SwitchList } from '../uiParts/settings/SwitchList';

const Settings = (props) => {
  const [loading, setLoading] = useState(true);
  const [cources, setCources] = useState([]);
  const [switches, setSwitches] = useState([]);
  const [filters, setFilters] = useState([]);
  const [options, setOptions] = useState([]);
  const { cm, init_cources, init_using_switches, init_switches, init_filters, init_options } = props;
  // 初期設定データセット
  useEffect(() => {
    setCources([...init_cources]);
    setSwitches([...init_switches]);
    setFilters([...init_filters]);
    setOptions([...init_options]);
    setLoading(false);
  }, []);

  const addCource = useCallback((new_item) => {
    setCources([...cources, new_item]);
  }, [cources]);
  const removeCource = useCallback((remove_item) => {
    setCources(cources.filter(cource => {
      return cource.id !== remove_item;
    }));
  }, [cources]);

  return (
    <>
      {loading ?
        <div className="d-flex justify-content-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
        :
        <Fragment>
          <label className="fw-bold">健診コース</label>
          <div className="cources">
            <CourceList 
              cm={cm} 
              items={cources} 
              filters={filters}
              options={options}
              addCource={addCource}
              removeCource={removeCource} />
          </div>
          <label className="fw-bold">指定方法</label>
          <div className="switches">
            <SwitchList cm={cm} items={switches} usingItems={init_using_switches} />
          </div>
        </Fragment>
      }
    </>
  );
};

export default Settings;
